import { render, staticRenderFns } from "./ShowFacebookCampaignOverviewAction.vue?vue&type=template&id=66f41d4b"
import script from "./ShowFacebookCampaignOverviewAction.vue?vue&type=script&lang=js"
export * from "./ShowFacebookCampaignOverviewAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports